// extracted by mini-css-extract-plugin
export var cancelButton = "_ne-5";
export var content = "_ne-3";
export var createButton = "_ne-6";
export var drawerContainer = "_ne-0";
export var footer = "_ne-2";
export var header = "_ne-1";
export var orderFormColumn = "_ne-4";